import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';

const GridSkeleton = () => {
  return (
    <Box
      sx={{
        display: 'grid !important',
        gridTemplateColumns: 'repeat(3, 1fr) !important',
        gap: 2,
        mt: 2
      }}
    >
      {[...Array(9)].map((_, index) => (
        <Paper
          key={index}
          sx={{
            p: 2,
            textAlign: 'center',
            backgroundColor: '#1B2335',
            borderRadius: '12px'
          }}
        >
          <Skeleton variant="rectangular" height={80} />
          <Skeleton variant="text" width="80%" sx={{ mt: 1 }} />
          <Skeleton variant="rectangular" height={30} sx={{ mt: 1 }} />
        </Paper>
      ))}
    </Box>
  );
};

export default GridSkeleton;